<template>
  <LoadingSpinner v-if="loading" data-testid="fractions-index__loadingSpinner" />
  <Fragment v-else>
    <SectionHeader :title="$t('meta.fractions')">
      <template v-slot:meta>
        <Link :to="`/company/fractions/new`" class="button button-green button-small button-round">
          {{ $t('fractions.addNew') }}
        </Link>
      </template>
    </SectionHeader>
    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('meta.fractions') }}</h3>
          </header>
          <div class="content-body">
            <Table data-testid="fractions-index__table">
              <template #header>
                <th>{{ $t('fractions.translations.en') }}</th>
                <th>{{ $t('fractions.translations.de') }}</th>
                <th>{{ $t('fractions.avvNumber') }}</th>
                <th>{{ $t('fractions.color') }}</th>
                <th class="table__th-actions">
                  {{ $t('meta.actions') }}
                </th>
              </template>
              <template #body>
                <tr v-for="fraction of fractions" :key="fraction.uuid" class="fractions-index__tr">
                  <td>{{ fraction.translations['en'] }}</td>
                  <td>{{ fraction.translations['de'] }}</td>
                  <td>{{ fraction.formattedAvvNumber }}</td>
                  <td>
                    <input
                      v-if="fraction.color"
                      type="color"
                      :value="fraction.color"
                      style="width: 50%; border: 0; padding: 0; background-color: white"
                      disabled
                    />
                    <span v-else>{{ $t('fractions.coloring.automatic') }}</span>
                  </td>
                  <td class="table__actions">
                    <Link class="table__action-button" :to="`/company/fractions/${fraction.uuid}`">
                      <span class="material-icons">edit</span>
                    </Link>
                    <button
                      :disabled="!fraction.can_be_deleted"
                      :title="deleteButtonText(fraction)"
                      @click="deleteFraction(fraction.uuid)"
                      class="table__action-button"
                    >
                      <span class="material-icons">delete</span>
                    </button>
                  </td>
                </tr>
              </template>
            </Table>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader/index.vue'
import Table from '@/components/Table/index.vue'
import CompanyNav from '@/components/company_nav.vue'

import fractionsApi from '@/api/companies/fractions'

export default {
  inject: ['companyUser', 'showPopup'],
  components: {
    CompanyNav,
    Fragment,
    LoadingSpinner,
    SectionHeader,
    Table,
  },
  data() {
    return {
      fractions: null,
      loading: true,
    }
  },
  methods: {
    async deleteFraction(fractionUuid) {
      const confirmAlert = await this.showPopup({ content: this.$t('fractions.deleteConfirmation'), type: 'confirm' })
      if (!confirmAlert) return null

      const response = await fractionsApi.delete(this.companyUser.company_uuid, fractionUuid)
      if (response.success) {
        this.fractions = await fractionsApi.getAll(this.companyUser.company_uuid)
      }
    },
    deleteButtonText(fraction) {
      if (!fraction.can_be_deleted) {
        return this.$t('fractions.cannotBeDeleted')
      }
    },
  },
  async created() {
    this.fractions = await fractionsApi.getAll(this.companyUser.company_uuid)
    this.loading = false
  },
}
</script>
